module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 5
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('CommonCostButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("CC" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v("Reason")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.reason))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("Vat " + _vm._s(_vm.item.tax * 100) + "%")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v("Total Amount")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.item.amount, _vm.item.tax).toFixed(2))))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v("Type")]), (_vm.item.common_cost_type_id) ? _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v("CT" + _vm._s(_vm.item.common_cost_type_id))]) : _vm._e(), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v(_vm._s(_vm.item.common_cost_type_name))])])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ad37e8f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/CommonCost.vue
// module id = 2176
// module chunks = 1